import {useState} from "react";
import "./../App.css";
import "./css/category.css";
import {Button, RoundButton} from "./../features/index";
import category from "./../assets/category.png";
import axios from "axios";
import {useNavigate, useSearchParams} from "react-router-dom";

const Category = () => {
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const handleCategorySelect = (categoryLabel) => {
        if (selectedCategories.includes(categoryLabel)) {
            setSelectedCategories(
                selectedCategories.filter((label) => label !== categoryLabel)
            );
        } else {
            setSelectedCategories([...selectedCategories, categoryLabel]);
        }
    };

    const submitCategory = async () => {
        const apiUrl = "https://dots-to-code2024-back.onrender.com/category"; // TODO: APIのURLを管理する関数をグローバルに作成
        const requestBody = {
            "user_id": searchParams.get("user_id"), // TODO: クエリパラメータから取得する
            "category_list": selectedCategories,
        };
        try {
            await axios.post(apiUrl, requestBody);
            navigate("/detail" + "?user_id=" + searchParams.get("user_id"));
        } catch (error) {
            console.error("エラーが発生しました:", error);
            setError("エラーが発生しました");
        }
    };

    const categories = {
        cosme_beauty: "コスメ・ビューティー",
        food_sweet: "食品・スイーツ",
        fashion: "ファッション",
        accessory: "アクセサリー",
        interior: "インテリア",
        flower_plant: "花・植物",
        kitchen_table_ware: "キッチン・テーブルウェア",
        hobby_lifestyle_supplies: "趣味・ライフスタイル雑貨",
        others: "その他",
    }

    return (
        <div className="category section">
            <div className="category__img">
                <img src={category} alt=""/>
            </div>
            <div className="category__text">何が欲しいですか?</div>
            <div className="category__container grid">
                {Object.entries(categories).map((item) => {
                    const categoryId = item[0];
                    const categoryName = item[1];
                    return <RoundButton
                        key={categoryId}
                        children={categoryName}
                        onClick={() => handleCategorySelect(categoryId)}
                        isSelected={selectedCategories.includes(categoryId)}
                    />
                })
                }
            </div>
            <div className="category__button">
                <Button
                    children={"次へ進む"}
                    onClick={() => submitCategory()}
                />
            </div>
            {error ? error : null}
        </div>
    )
        ;
};

export default Category;
